<template>
  <div>
    <v-flex v-if="loading" class="loading">
      <v-progress-circular indeterminate class="primary--text"></v-progress-circular>
    </v-flex>

    <v-flex xs12 v-else >
      <v-card
        width="300"
        class="elevation-8"
        style="border-radius: 10px;"
      >
        <v-tooltip top>
          <div slot="activator">
        <v-img
          style="border-top-left-radius: 10px; border-top-right-radius: 10px;"
          :src="product.img"
          aspect-ratio="3.15"
          
        ></v-img>

        <v-card-title primary-title>
          <div class="text-xs-left">
            <div class="headline mb-0 font-weight-bold title">{{ product.title }}</div>
            <div class="py-2"> {{ product.shortdesc }} </div>
            <div class="font-weight-bold">{{ product.price }}</div>
          </div>
        </v-card-title>
        </div>
        <span>En cliquant, l'internaute verra le produit <br>dans une fenêtre flottante</span>
          </v-tooltip>

        <v-card-actions v-if="product.addtocart">
          <v-tooltip top>
            <template slot="activator">
              <v-btn small color="info">Ajouter au panier</v-btn>
            </template>
            <span>En cliquant,<br>l'internaute mettra le produit<br>au panier</span>
          </v-tooltip>
        </v-card-actions>
      </v-card>

      <v-flex xs12>
        <div class="text-xs-right">
          <v-tooltip top>
            <v-btn slot="activator" flat icon small color="primary" @click.stop="openDialogUpdate()">
              <v-icon>edit</v-icon>
            </v-btn>
            <span>Modifier ce produit</span>
          </v-tooltip>

          <v-tooltip top>
            <v-btn slot="activator" flat icon small color="primary" @click.stop="openDialogMove()">
              <v-icon>content_paste_go</v-icon>
            </v-btn>
            <span>changer de famille ce produit</span>
          </v-tooltip>

          <v-tooltip top>
            <v-btn slot="activator" flat icon small color="primary" @click.stop="openDialogDelete()">
              <v-icon>delete</v-icon>
            </v-btn>
            <span>Supprimer ce produit</span>
          </v-tooltip>
        </div>
      </v-flex>
    </v-flex>

    <v-dialog v-model="showDialogUpdate" persistent max-width="600">
      <v-card>
        <v-card-title class="primary white--text">{{ $t('edit') | cap }} {{ $tc('products', 1) }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-text-field
            label="Référence produit*" 
            v-model="productDialog.ref"
          ></v-text-field>
          <v-text-field
            label="Nom du produit*" 
            v-model="productDialog.title"
            required
            data-vv-name="productInput"
            v-validate="'required'"
            :error="wzErrors.has('productInput')"
            :errors="wzErrors.collect('productInput')"
          ></v-text-field>
          <v-text-field 
            label="Description courte" 
            v-model="productDialog.shortdesc"
          ></v-text-field>
          <v-textarea 
            label="Mots clés (séparés par virgule)" 
            v-model="productDialog.keywords"
          ></v-textarea>
          <v-text-field 
            label="Prix" 
            v-model="productDialog.price"
          ></v-text-field>
          <v-text-field 
            label="Lien WEB" 
            v-model="productDialog.link"
          ></v-text-field>
          <v-text-field 
            label="Lien image/photo*" 
            v-model="productDialog.img"
          ></v-text-field>
          <v-flex xs12>
            <v-switch 
              :label="productDialog.addtocart ? 'Boutton panier affiché' : 'Boutton panier masqué'" 
              v-model="productDialog.addtocart"
              light
              color="primary"
            ></v-switch>
          </v-flex>
          <small>*{{ $t('required') }}</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn flat @click="showDialogUpdate = false">{{ $t('cancel') }}</v-btn>
          <v-btn color="primary" :disabled="wzErrors.any()" @click="submitDialogUpdate">{{ $t('submit') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showDialogMove" max-width="290">
      <v-card>
        <v-card-title class="primary white--text">{{ $t('move') | cap }} {{ $tc('products', 1) }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-select
              label="Choisissez la collection / famille"
              v-model="rayonSelectId"
              :items="$store.getters['_Rayons/GET_ALL_RAYON_TITLE']"
              required
          ></v-select>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn flat @click="showDialogMove = false">{{ $t('cancel') }}</v-btn>
          <v-btn color="primary" @click="submitDialogMove">{{ $t('submit') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showDialogDelete" max-width="290">
      <v-card>
        <v-card-title class="primary white--text">{{ $t('delete') | cap }} {{ $tc('products', 1) }}</v-card-title>
        <v-card-text>
          {{ $t('delete') | cap }} {{ $tc('products', 1) }}?
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn flat @click.native="showDialogDelete = false">{{ $t('no') }}</v-btn>
          <v-btn color="primary" @click.native="submitDialogDelete">{{ $t('yes') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import _ from 'lodash'

export default {

  props: {
    rayon: {
      type: Object,
      required: true
    },
    product: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      /**
       * affiche/cache la fenetre de dialog de modification
       * @type {Boolean}
       */
      showDialogUpdate: false,
      /**
       * affiche/cache la fenetre de dialog de suppression
       * @type {Boolean}
       */
      showDialogDelete: false,
      /**
       * affiche/cache la fenetre de dialog de déplacement
       * @type {Boolean}
       */
      showDialogMove: false,
      /**
       * product qui sera utilisée dans la fenêtre de dialogue de modification
       * @type {Object}
       */
      productDialog: {},
      /**
       * Identifiant du rayon qui est manipulée dans le select
       */
      rayonSelectId: this.rayon.id,
      loading: false,
      overMenu: false
    }
  },

  methods: {
    openDialogUpdate () {
      if (!this.overMenu) {
        this.productDialog = _.clone(this.product)
        this.showDialogUpdate = true
      }
    },
    openDialogMove () {
      this.productDialog = _.clone(this.product)
      this.showDialogMove = true
    },
    openDialogDelete () {
      this.productDialog = _.clone(this.product)
      this.showDialogDelete = true
    },
    submitDialogUpdate () {
      this.showDialogUpdate = false

      let dataToPost = new window.FormData()
      dataToPost.append('PRO_ID', this.productDialog.id)
      dataToPost.append('PRO_REF', this.productDialog.ref)
      dataToPost.append('PRO_NAME', this.productDialog.title)
      dataToPost.append('PRO_LINK', this.productDialog.link)
      dataToPost.append('PRO_IMG', this.productDialog.img)
      dataToPost.append('PRO_SHORTDESC', this.productDialog.shortdesc)
      dataToPost.append('PRO_KEYWORDS', this.productDialog.keywords)
      dataToPost.append('PRO_PRICE', this.productDialog.price)
      dataToPost.append('PRO_RAY_ID', this.rayon.id)
      dataToPost.append('PRO_ADDTOCART', this.productDialog.addtocart ? 1 : 2)
      this.loading = true
      this.axios.post('put/product.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
      .then(response => {
        // modification du rayon dans la liste des rayons
        let rayonUpdate = _.cloneDeep(this.rayon)
        let productsUpdate = []
        for (var i = 0; i < rayonUpdate.products.length; i++) {
          // si la product passé en paramètre correspond à une existante
          // alors changement de titre pour ce product
          if (rayonUpdate.products[i].id === this.productDialog.id) {
            productsUpdate.push(this.productDialog)
          } else {
            productsUpdate.push(rayonUpdate.products[i])
          }
        }
        rayonUpdate.products = productsUpdate
        this.$store.commit('_Rayons/UPDATE_RAYON', rayonUpdate)
        this.$emit('update:rayon', rayonUpdate)
        // Notification
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('modifSuccess'), context: 'success' })
      })
      .catch(_ => {
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('modifFailure'), context: 'error' })
      })
      .then(_ => {
        this.loading = false
      })
    },
    submitDialogMove () {
      this.showDialogMove = false
      // il y a eu changement dans le select (i.e. ce n'est pas la même rayon qui est sélectionnée)
      if (this.rayonSelectId !== this.rayon.id) {
        let dataToPost = new window.FormData()
        dataToPost.append('PRO_ID', this.product.id)
        dataToPost.append('PRO_NAME', this.product.title)
        dataToPost.append('PRO_RAY_ID', this.rayonSelectId)
        this.loading = true
        this.axios.post('put/move_product.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
        .then(response => {
          // suppression de product dans le rayon actuel
          this.$emit('update:rayon', this.deleteProduct())

          // ajout de product dans la rayon pointée par le select
          let rayonUpdate = _.cloneDeep(this.$store.getters['_Rayons/GET_RAYON_BY_ID'](this.rayonSelectId))
          rayonUpdate.products.push(this.product)
          this.$store.commit('_Rayons/UPDATE_RAYON', rayonUpdate)
          // BUGGGGGGGGGGGGGGGG
          // attention si on bascule un produit vers un sub-rayon, alors que les sub-rayon ne sont pas dans les GET_RAYON_BY_ID... alors le code en dessous ne fonctionne pas... et le produit ne sera pas visible dans le subrayon (sauf à rechacher tout le get/prodducts

          // Notification
          this.$store.dispatch('_Notifier/NEW_NOTIF', {context: 'success'})
        })
        .catch(_ => {
          this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('modifFailure'), context: 'error' })
        })
        .then(_ => {
          this.loading = false
        })
      }
    },
    submitDialogDelete () {
      this.showDialogDelete = false
      let dataToPost = new window.FormData()
      dataToPost.append('PRO_ID', this.product.id)
      this.loading = true
      this.axios.post('delete/product.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
      .then(response => {
        // suppression de la product dans la liste des products
        this.$emit('update:rayon', this.deleteProduct())
        // Notification
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('deleteSuccess'), context: 'success' })
      })
      .catch(_ => {
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('deleteFailure'), context: 'error' })
      })
      .then(_ => {
        this.loading = false
      })
    },
    deleteProduct () {
      let rayonUpdate = _.cloneDeep(this.rayon)
      // suppression de la product dans le rayon
      let productsUpdate = _.differenceWith(this.rayon.products, [this.productDialog], _.isEqual)
      // actualisation des products de le rayon
      rayonUpdate.products = productsUpdate
      this.$store.commit('_Rayons/UPDATE_RAYON', rayonUpdate)
      return rayonUpdate
    },
    openLink () {
      window.open(this.product.link, '', 'width=500, height=600')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/watcheezy/WzProduct.vue